class Tracking {
    constructor() {
        this.trackSearch()
        this.searchQsToJSON()
    }
    trackResultsItemViewed(cottage) {
        window.dataLayerQueue.push({
            'event': 'resultsItemViewed'
            , 'cottageCode': typeof (cottage.cottageCode) === 'undefined' ? '' : cottage.cottageCode
            , 'position': typeof (cottage.position) === 'undefined' ? '' : cottage.position
            , 'searchQuery': typeof (cottage.queryString) === 'undefined' ? '' : cottage.queryString
            , 'searchParams': typeof (cottage.params) === 'undefined' ? '' : cottage.params
        });        
    }
    trackComplexResultViewed(complex) {
        window.dataLayerQueue.push({
            'event': 'resultsComplexViewed'
            , 'complexCode': typeof (complex.complexCode) === 'undefined' ? '' : complex.complexCode
            , 'cottageCodes': typeof (complex.complexCodes) === 'undefined' ? '' : complex.complexCodes
            , 'position': typeof (complex.position) === 'undefined' ? '' : complex.position
            , 'searchQuery': typeof (complex.queryString) === 'undefined' ? '' : complex.queryString
            , 'searchParams': typeof (complex.params) === 'undefined' ? '' : complex.params
        });      
    }
   
    trackSearch(state, params) {
        if (typeof (state) !== 'undefined') {
            let qs = window.location.href.split("?")[1]
            window.dataLayerQueue.push({
                'event': 'Search'
                , 'arrivalDate': typeof (state.dss) === 'undefined' ? '' : state.dss
                , 'departureDate': typeof (state.des) === 'undefined' ? '' : state.des
                , 'pets': typeof (state.pet) === 'undefined' ? '' : state.pet
                , 'party': typeof (state.minA) === 'undefined' ? '' : state.minA
                , 'nights': typeof (state.nday) === 'undefined' ? '' : state.nday
                , 'location': typeof (params.locationName) === 'undefined' ? '' : params.locationName
                , 'bedrooms': typeof (state.bed) === 'undefined' ? '' : state.bed
                , 'bathrooms': typeof (state.bath) === 'undefined' ? '' : state.bath
                , 'resultsCount': typeof (params.totalCount) === 'undefined' ? '' : params.totalCount
                , 'sortOrder': typeof (state.sorting) === 'undefined' ? '' : state.sorting
                , 'searchQuery': qs
                , 'searchParams': this.searchQsToJSON(state)
            });
        }
    }

    searchQsToJSON(queryString) {
        let params = new URLSearchParams(queryString);
        let json = {};
        params.forEach(function (value, key) {
            if (!json.hasOwnProperty(key)) {
                json[key] = value;
            } else {
                if (!Array.isArray(json[key])) {
                    json[key] = [json[key]];
                }
                json[key].push(value);
            }
        });
        return JSON.stringify(json);
    }
}

export default Tracking
